"use client";

import { ReactNode, useCallback } from "react";

import MultiCarousel from "@stadium/ui/src/components/multi-carousel";
import useWithAnalytics from "@stadium/services/analytics/hooks/use-with-analytics";
import { ANALYTICS_EVENT_ACTION_NAVIGATED } from "@stadium/services/analytics/constants/default";
import { ANALYTICS_TARGET_CATEGORY_CAROUSEL } from "./constant";

type EventLocationAnalytics = {
  eventProperties?: Record<string, unknown>;
};

export const TrackedCategoryCarousel = ({
  children,
  eventLocationAnalytics,
  ...props
}: { children: ReactNode; eventLocationAnalytics: EventLocationAnalytics } & Record<
  string,
  unknown
>) => {
  const withAnalytics = useWithAnalytics();

  const handleAfterChange = useCallback(() => {
    withAnalytics(undefined, {
      track: true,
      target: ANALYTICS_TARGET_CATEGORY_CAROUSEL,
      action: ANALYTICS_EVENT_ACTION_NAVIGATED,
      eventProperties: eventLocationAnalytics?.eventProperties ?? {},
    })();
  }, [withAnalytics, eventLocationAnalytics?.eventProperties]);

  return (
    // @ts-expect-error -- MultiCarousel is a JSX component without explicit TS types for afterChange
    <MultiCarousel {...props} afterChange={handleAfterChange}>
      {children}
    </MultiCarousel>
  );
};
